export default __webpack_public_path__ + "static/media/work-update.bf67ecf7.svg";